export default __webpack_public_path__ + "static/media/T735_SOV.647de74b.pdf";